module.exports = __webpack_public_path__ + "static/icon-competitive-4.b0e3ca3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-competitive-4.svg
// module id = 196
// module chunks = 35783957827783 267625579013595